import React, { useMemo } from 'react';
import './HuangliCard.css';
import { Solar, Lunar, Foto } from 'lunar-javascript';
import { getGanWuxing, getZhiWuxing, getWuxingColor } from '../utils/wuxing-calculator';

function startOfDay(d) { const x = new Date(d); x.setHours(0,0,0,0); return x; }

function formatRelative(date) {
  const today = startOfDay(new Date());
  const diff = Math.round((startOfDay(date) - today) / 86400000);
  if (diff === 0) return '今天';
  if (diff > 0) return `${diff}天后`;
  return `${Math.abs(diff)}天前`;
}

const WEEK_NAMES = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];

// 干支小盘：干/支按五行着色（万年历当日四柱用，无日主故不标十神）
const PillarMini = ({ label, ganZhi }) => {
  const gan = ganZhi?.[0] || '';
  const zhi = ganZhi?.[1] || '';
  return (
    <div className="sizhu-pillar">
      <div className="sizhu-plabel">{label}</div>
      <div className="sizhu-chars">
        <span className="sizhu-char" style={{ color: getWuxingColor(getGanWuxing(gan)) }}>{gan}</span>
        <span className="sizhu-char" style={{ color: getWuxingColor(getZhiWuxing(zhi)) }}>{zhi}</span>
      </div>
    </div>
  );
};

export default function HuangliCard({ date }) {
  const solar = useMemo(() => Solar.fromDate(date), [date]);
  const lunar = useMemo(() => Lunar.fromDate(date), [date]);

  const line1 = `${formatRelative(date)}  ${WEEK_NAMES[date.getDay()]}  ${solar.getYear()}年${String(solar.getMonth()).padStart(2,'0')}月`;
  const line2 = solar.getDay();
  const lunarMonth = lunar.getMonthInChinese();
  const lunarDay = lunar.getDayInChinese();
  const line3 = `农历${lunarMonth}月${lunarDay}`;
  const gzYear = lunar.getYearInGanZhi();
  const gzMonth = lunar.getMonthInGanZhi();
  const gzDay = lunar.getDayInGanZhi();
  const shengxiao = lunar.getYearShengXiao();
  const line4 = `${gzYear}年(${shengxiao}年)${gzMonth}月${gzDay}日`;

  const yiArr = lunar.getDayYi?.() || [];
  const jiArr = lunar.getDayJi?.() || [];

  const jq = lunar.getJieQi?.();
  const foto = useMemo(() => Foto.fromLunar(lunar), [lunar]);
  const buddhistMemorials = (foto.getOtherFestivals?.() || []).map((x) => x?.toString?.() || x);
  const buddhistTaboos = (foto.getFestivals?.() || []).map(x => x?.toFullString?.() || x?.toString?.() || x);

  return (
    <div className="huangli-card">
      <div className="header">
        <div className="line1">{line1}</div>
        <div className="line2">{line2}</div>
        <div className="line3">{line3}{jq ? `　｜　${jq}` : ''}</div>
        <div className="line4">{line4}</div>
      </div>

      {/* 当日四柱（年/月/日；时柱不定，略） */}
      <div className="sizhu-row">
        <PillarMini label="年柱" ganZhi={gzYear} />
        <PillarMini label="月柱" ganZhi={gzMonth} />
        <PillarMini label="日柱" ganZhi={gzDay} />
      </div>

      <div className="yiji">
        <div className="yiji-box yiji-box-good">
          <div className="yiji-title yiji-good">宜</div>
          <div className="chip-list">
            {yiArr.length > 0 ? yiArr.map((t, i) => <span key={i} className="chip chip-good">{t}</span>) : <span className="chip-empty">——</span>}
          </div>
        </div>
        <div className="yiji-box yiji-box-bad">
          <div className="yiji-title yiji-bad">忌</div>
          <div className="chip-list">
            {jiArr.length > 0 ? jiArr.map((t, i) => <span key={i} className="chip chip-bad">{t}</span>) : <span className="chip-empty">——</span>}
          </div>
        </div>
      </div>

      <div className="buddhist-line">
        <span className="badge badge-era">佛历 {foto.getYear()}年{String(foto.getMonth()).padStart(2,'0')}月{String(foto.getDay()).padStart(2,'0')}日</span>
        {buddhistMemorials.map((m, i) => <span key={`m${i}`} className="badge badge-memorial">{m}</span>)}
        {buddhistTaboos.map((t, i) => <span key={`t${i}`} className="badge badge-taboo">{t}</span>)}
      </div>
    </div>
  );
}
